(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9723],{

/***/ 46254:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/meta/blog",
      function () {
        return __webpack_require__(13185);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 51557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AX": function() { return /* binding */ increaseAgreeCount; },
/* harmony export */   "mf": function() { return /* binding */ GenericAgreeStats; },
/* harmony export */   "sW": function() { return /* binding */ fetchAgreeStats; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38509);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89513);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2413);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44725);
/* harmony import */ var src_components_Splash_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8457);
/* harmony import */ var src_components_UI_Buttons_ButtonWithLoading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80615);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 





var fetchAgreeStats = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(title) {
        var res, data;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return fetch("/api/agree?".concat(new URLSearchParams({
                        title: title
                    })), {
                        method: "GET"
                    });
                case 3:
                    res = _ctx.sent;
                    data = res.json();
                    _ctx.next = 7;
                    return data;
                case 7:
                    return _ctx.abrupt("return", _ctx.sent);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }));
    return function fetchAgreeStats(title) {
        return _ref.apply(this, arguments);
    };
}();
var increaseAgreeCount = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(title) {
        var res, data;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return fetch("/api/agree", {
                        method: "POST",
                        body: JSON.stringify({
                            title: title
                        })
                    });
                case 3:
                    res = _ctx.sent;
                    data = res.json();
                    _ctx.next = 7;
                    return data;
                case 7:
                    return _ctx.abrupt("return", _ctx.sent);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }));
    return function increaseAgreeCount(title) {
        return _ref.apply(this, arguments);
    };
}();
var GenericAgreeStats = function(param) {
    var title = param.title, buttonText = param.buttonText, tableText = param.tableText, buttonWidth = param.buttonWidth;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), stats = ref[0], setStats = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), loading = ref1[0], setLoading = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        fetchAgreeStats(title).then(function(someStats) {
            setStats(someStats);
            setLoading(false);
        });
    }, [
        title
    ]);
    var handleQuotaIncrease = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var newQuota;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.next = 3;
                        return increaseAgreeCount(title);
                    case 3:
                        newQuota = _ctx.sent;
                        setStats(newQuota);
                        setLoading(false);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleQuotaIncrease() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(src_components_Splash_styles__WEBPACK_IMPORTED_MODULE_3__/* .ButtonAndStatsContainer */ .T, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_UI_Buttons_ButtonWithLoading__WEBPACK_IMPORTED_MODULE_4__/* .ButtonWithLoading */ .y, {
                handleClick: handleQuotaIncrease,
                loading: loading,
                width: buttonWidth,
                children: buttonText
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_Splash_styles__WEBPACK_IMPORTED_MODULE_3__/* .RightAlignedStats */ .R, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("table", {
                    className: "tg",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("tbody", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("th", {
                                    className: "tg",
                                    children: [
                                        " ",
                                        tableText
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                    className: "tg",
                                    children: stats ? stats.agreeCount : "λ"
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 59989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ PostCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2413);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26235);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91865);
/* harmony import */ var src_components_Splash_LDBlock__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91881);
/* harmony import */ var src_lib_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30440);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 




function PostCard(param) {
    var post = param.post;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "".concat(src_lib_constants__WEBPACK_IMPORTED_MODULE_4__/* .AppRoutes.Blog */ .$w.Blog, "/").concat(post.slug),
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_Splash_LDBlock__WEBPACK_IMPORTED_MODULE_3__/* .LDLinkBlock */ .sw, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_2__/* .LDBlockHeading */ .nL, {
                    children: post.title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_2__/* .LDBlockDate */ .Yf, {
                    children: post.date
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_2__/* .LDBlockParagraph */ .yC, {
                    children: post.description
                })
            ]
        })
    }, post.slug);
}


/***/ }),

/***/ 8457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ RightAlignedStats; },
/* harmony export */   "T": function() { return /* binding */ ButtonAndStatsContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48876);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: 10px;\n  height: 35px;\n  font-weight: 500;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding-top: 36px;\n  padding-bottom: 6px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var RightAlignedStats = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f8332909-0"
})(_templateObject());
var ButtonAndStatsContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f8332909-1"
})(_templateObject1());


/***/ }),

/***/ 13185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Blog; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2413);
/* harmony import */ var src_components_Splash_PostCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59989);
/* harmony import */ var src_components_Splash_PostTemplate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92980);
/* harmony import */ var src_lib_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30440);
/* harmony import */ var src_pages_meta_blog_funding_2022__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10147);
/* harmony import */ var src_pages_meta_blog_signup_with_urbit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74961);
/* harmony import */ var src_pages_meta_blog_the_year_2022__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89228);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 






var POSTS = [
    src_pages_meta_blog_signup_with_urbit__WEBPACK_IMPORTED_MODULE_5__.SIGNUP_WITH_URBIT_POST_ATTRS,
    src_pages_meta_blog_funding_2022__WEBPACK_IMPORTED_MODULE_4__.FUNDING_POST_ATTRS,
    src_pages_meta_blog_the_year_2022__WEBPACK_IMPORTED_MODULE_6__.THE_YEAR_2022_POST_ATTRS
];
function Blog() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_PostTemplate__WEBPACK_IMPORTED_MODULE_2__/* .PostTemplate */ .F, {
        leftLink: src_lib_constants__WEBPACK_IMPORTED_MODULE_3__/* .AppRoutes.Meta */ .$w.Meta,
        leftLinkText: "HOME",
        rightLink: src_lib_constants__WEBPACK_IMPORTED_MODULE_3__/* .AppRoutes.Jobs */ .$w.Jobs,
        rightLinkText: "JOBS",
        children: POSTS.map(function(post) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_PostCard__WEBPACK_IMPORTED_MODULE_1__/* .PostCard */ .y, {
                post: post
            }, post.slug);
        })
    });
};


/***/ }),

/***/ 89228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "THE_YEAR_2022_POST_ATTRS": function() { return /* binding */ THE_YEAR_2022_POST_ATTRS; },
/* harmony export */   "default": function() { return /* binding */ Post; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2413);
/* harmony import */ var src_components_Splash_GenericAgreeStats__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51557);
/* harmony import */ var src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91865);
/* harmony import */ var src_components_Splash_LDBlock__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91881);
/* harmony import */ var src_components_Splash_PostTemplate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92980);
/* harmony import */ var src_lib_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30440);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 





var THE_YEAR_2022_POST_ATTRS = {
    title: "Some Thoughts on the Internet",
    SEOtitle: "Some Thoughts on the Internet",
    date: "May 10, 2022",
    slug: "the-year-2022",
    description: "The internet was supposed to be a giant leap toward techno utopia. It was supposed to be a tool that would allow each of us to peacefully, thoughtfully, and creatively live fulfilling lives. But it has turned out to be nothing more than..."
};
function Post() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_PostTemplate__WEBPACK_IMPORTED_MODULE_4__/* .PostTemplate */ .F, {
        leftLink: src_lib_constants__WEBPACK_IMPORTED_MODULE_5__/* .AppRoutes.Meta */ .$w.Meta,
        leftLinkText: "HOME",
        rightLink: "",
        rightLinkText: "",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_Splash_LDBlock__WEBPACK_IMPORTED_MODULE_3__/* .LDBlock */ .zB, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_2__/* .LDBlockHeading */ .nL, {
                    children: THE_YEAR_2022_POST_ATTRS.title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_2__/* .LDBlockDate */ .Yf, {
                    children: THE_YEAR_2022_POST_ATTRS.date
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_2__/* .LDBlockSubheading */ .s1, {
                    children: "The Year 2022"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_2__/* .LDBlockParagraph */ .yC, {
                    children: "The internet was supposed to be a giant leap toward techno utopia. It was supposed to be a tool that would allow each of us to peacefully, thoughtfully, and creatively live fulfilling lives. But it has turned out to be nothing more than a giant media company."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_2__/* .LDBlockParagraph */ .yC, {
                    children: "Almost every aspect of our culture has been commercialized, sanitized, and packaged. Computing, now quite far from the escape the 60’s dreamed of, only managed to create a new generation of internet mega corps, who in turn invented a new, digital breed of consumerism."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_2__/* .LDBlockParagraph */ .yC, {
                    children: "These corporations have near total control over the flow of information in our society. By controlling what is posted and consumed, they determine the overall culture, the overall values, and the overall truths."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_2__/* .LDBlockParagraph */ .yC, {
                    children: "Large internet companies, who already enjoy special access to our government, are trending toward something much darker. The end result looks to be that the churning industrial machine that is internet technology will merge into the machine of the state at the highest level, and the internet will become yet another tool of state control."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_2__/* .LDBlockParagraph */ .yC, {
                    children: [
                        "Without fundamental changes to everyday life on the internet, we are all destined to become digital serfs, ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                            children: "continually driven to distraction by the constant assault of form without meaning."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_GenericAgreeStats__WEBPACK_IMPORTED_MODULE_1__/* .GenericAgreeStats */ .mf, {
                    title: "Some Thoughts on the Internet in 2021",
                    buttonText: "Agree",
                    tableText: "Agrees",
                    buttonWidth: "150px"
                })
            ]
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2349,147,4961,9774,2888,179], function() { return __webpack_exec__(46254); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);